export const RESET_STORE = "reset/all";
export const INITIALIZE = "init/all";

export const initializeEvent = () => ({ type: INITIALIZE });
